import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { DashBoardApiService } from 'features/Dashboard/api/dashboard-api.service';
import { queryClient } from 'providers';

import { DashboardQueryKeys } from './query-keys';
const { CreateselectCompany } = DashBoardApiService();

export const useCreateSelectCompany = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: FormData) => {
      return CreateselectCompany(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: DashboardQueryKeys.all,
        });
      },
    },
  );
};
